import { styled, Box } from '@material-ui/core';
import { QRCodeSVG } from 'qrcode.react';

const QRCodeCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  backgroundColor: theme.palette.grey[300],
  borderRadius: 12,
  padding: 24,
  maxWidth: 518,
  margin: '0 auto',
}));

const QRCode = styled(QRCodeSVG)({
  flexShrink: 0,
});

const StoreImgWrapper = styled('a')({
  display: 'flex',
  justifyContent: 'center',
  width: 'fit-content',
  margin: '16px auto 0',
});

export {
  QRCodeCard,
  QRCode,
  StoreImgWrapper,
};
